<template>
  <div v-if="isVisible" class="recommenders-modal">
    <div class="modal-backdrop" @click="$emit('closeRecommendersModal')"></div>

    <div class="modal-card">
      <div class="modal-header">
        <h3>Szczegóły poleceń</h3>
        <button class="btn-icon" @click="$emit('closeRecommendersModal')" title="Zamknij">
          <img src="@/assets/icons/x.svg" alt="zamknij">
        </button>
      </div>

      <div class="table-wrapper" v-if="recommenders && recommenders.length > 0">
        <table class="recommenders-table">
          <thead>
          <tr>
            <th>ID</th>
            <th>E-mail</th>
            <th>Data</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="recommender in recommenders" :key="recommender.register_id">
            <td>{{ recommender.register_id }}</td>
            <td class="email-cell">{{ recommender.register_email }}</td>
            <td>{{ recommender.updated_at.split('T')[0] }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div v-else class="empty-state">
        Brak poleceń do wyświetlenia.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecommendersModal',
  props: ['isVisible', 'recommenders'],
};
</script>

<style scoped lang="scss">
.recommenders-modal {
  position: fixed;
  inset: 0;
  z-index: 120;
}

.modal-backdrop {
  position: absolute;
  inset: 0;
  background-color: rgba(17, 24, 39, 0.65);
  backdrop-filter: blur(2px);
}

.modal-card {
  position: absolute;
  top: 50%;
  left: 50%;
  width: calc(100% - 24px);
  max-width: 680px;
  transform: translate(-50%, -50%);
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 16px 50px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;

  h3 {
    margin: 0;
    color: #1f2937;
    font-size: 1.9rem;
    font-weight: 700;
  }
}

.table-wrapper {
  padding: 14px;
  max-height: min(65vh, 520px);
  overflow: auto;
}

.recommenders-table {
  width: 100%;
  min-width: 520px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.recommenders-table th,
.recommenders-table td {
  border-bottom: 1px solid #f1f5f9;
  padding: 10px 12px;
  text-align: left;
  font-size: 1.4rem;
  vertical-align: middle;
}

.recommenders-table th {
  background: #f9fafb;
  color: #374151;
  font-weight: 700;
}

.recommenders-table td {
  color: #1f2937;
}

.recommenders-table tr:last-child td {
  border-bottom: none;
}

.recommenders-table tbody tr:hover td {
  background-color: #fcfcfd;
}

.email-cell {
  word-break: break-word;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.2s;
}

.btn-icon:hover {
  background-color: #f3f4f6;
}

.btn-icon img {
  width: 20px;
  height: 20px;
}

.empty-state {
  padding: 20px 16px;
  color: #9ca3af;
  font-size: 1.5rem;
  text-align: center;
}

@media (max-width: 480px) {
  .modal-card {
    border-radius: 8px;
  }

  .modal-header h3 {
    font-size: 1.7rem;
  }

  .table-wrapper {
    padding: 10px;
  }

  .recommenders-table th,
  .recommenders-table td {
    font-size: 1.3rem;
    padding: 8px 10px;
  }
}
</style>